<template>
  <article>
    <Toolbar />

    <v-container>
      <h1 class="black--text">{{ name }} SLOs</h1>
      <div v-if="$apollo.loading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="blue"
          indeterminate
        ></v-progress-circular>
      </div>

      <v-layout v-else row wrap pa-3 v-for="(slo, idx) of slos" :key="idx">
        <v-flex xs12>
          <SLOSummary :slo="slo" />
        </v-flex>
      </v-layout>
      <NewAppSLO :newApp="false" :appName="name" />
    </v-container>
  </article>
</template>

<script>
import SLOSummary from "@/components/SLOSummary";
import NewAppSLO from "@/components/NewAppSLO";
import Toolbar from "@/components/Toolbar.vue";

import gql from "graphql-tag";

export default {
  name: "App",
  components: {
    Toolbar,
    SLOSummary,
    NewAppSLO
  },
  props: {
    name: {
      type: String,
      required: true
    }
  },
  apollo: {
    apps: {
      query: gql`query appQuery($name: String!) {
        apps(name: $name) {
          name
          rateSlos {
            id
            name
            minPercent
            intervalHours
            currentPercent
            currentErrorBudget {
              totalBudget
              remainingBudget
            }
          }
        }
      }`,
      variables() {
        return {
          name: this.name
        };
      }
    }
  },
  computed: {
    slos() {
      if (!this.apps || this.apps.length == 0) {
        return [];
      }
      return this.apps[0].rateSlos;
    }
  },
  data () {
    return {
      apps: []
    };
  }
};
</script>
